export default __webpack_public_path__ + "static/media/dark-fb.f366353e.svg";